export const engagementCanvasStatsWorkflowId = "/engagement/canvas/stats/:workflow_id";
